module.exports = __webpack_public_path__ + "img/mullins-island-city-rossing.8dee609b.jpg";